import { render, staticRenderFns } from "./BookingStatus.vue?vue&type=template&id=3164236c&"
import script from "./BookingStatus.vue?vue&type=script&lang=js&"
export * from "./BookingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports